// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';

import TARGET_BY_STUDENT_ID_CONTAINER_QUERY from 'chat/components/SplitComposer/queries/TargetByStudentIdContainerQuery.gql';
import { ComposerDispatchContext } from 'chat_v2/ComposerContext';

import type {
  TargetByStudentIdContainer as TargetByStudentIdContainerData,
  TargetByStudentIdContainer_organizations,
} from 'chat/components/SplitComposer/queries/__generated__/TargetByStudentIdContainer';

type Props = {
  children: Function,
  schoolUuids: string[],

  // graphql data
  data: ReactApolloData<TargetByStudentIdContainerData>,
};

class TargetByStudentIdContainer extends React.Component<Props, void> {
  isLoading = (props: Props): boolean => {
    return props.data.loading || props.data.networkStatus < 7;
  };

  getOrgs = (props: Props): $ReadOnlyArray<?TargetByStudentIdContainer_organizations> | null => {
    return props.data.organizations || null;
  };

  render() {
    return (
      <ComposerDispatchContext.Consumer>
        {dispatch =>
          this.props.children({
            loading: this.isLoading(this.props),
            schools: this.getOrgs(this.props),
            selectStudentIdListRecipient: entity => dispatch({ type: 'addRecipient', entity }),
            clearSelection: () => dispatch({ type: 'removeAllRecipients' }),
          })
        }
      </ComposerDispatchContext.Consumer>
    );
  }
}

const withOrgs = graphql(TARGET_BY_STUDENT_ID_CONTAINER_QUERY, {
  options: ({ schoolUuids }) => ({
    variables: {
      uuids: schoolUuids,
    },
  }),
});

export { TargetByStudentIdContainer };

export default withOrgs(TargetByStudentIdContainer);
